import { render, staticRenderFns } from "./LanguageCharts.vue?vue&type=template&id=4be4feb1&scoped=true"
import script from "./LanguageCharts.vue?vue&type=script&lang=js"
export * from "./LanguageCharts.vue?vue&type=script&lang=js"
import style0 from "./LanguageCharts.vue?vue&type=style&index=0&id=4be4feb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be4feb1",
  null
  
)

export default component.exports